import React from "react"
import { DetailsPopup } from "modules/common/components/form/DetailsPopup"
import { Block } from "modules/common/components/page/Block"
import { matchRoute } from "modules/common/services/routing";
import { WhenPath } from "modules/common/components/routing/WhenPath";
import { routes } from "modules/common/routes"
import { observer } from "mobx-react"
import { texts } from "modules/common/texts"
import { EMPTY_OBJECT_ID } from "modules/common/constants"
import { EmployeeStoreType } from "../models/employee-store"
import { EmployerDetails } from "./details/EmployerDetails"
import { EmployerCardTitle } from "./EmployerCardTitle"
import { EmployerList } from "./list/EmployerList"
import { menuItems } from "modules/root/components/menu/MainMenu"
import func from "../../functionalities"
import { can, canAny } from "modules/session/auth/access"
import { Search } from "modules/common/components/form/Search"
import { RemovedList } from "./list/RemovedList"
import { Dialog, Classes, Spinner } from "@blueprintjs/core"
import styles from "./EmployeePage.module.scss"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { canReadOrder } from "modules/orders-manage/functionalities"
import { MaterialValuesStoreType } from "modules/dictionaries/inventory/models/material-value-store"
import { MenuItem } from "@blueprintjs/core"
import { ItemRenderer, MultiSelect } from "@blueprintjs/select"
import { filterItemPredicate, matchTargetWidthPopover } from "modules/common/services/form/select"
import { SessionType } from "modules/session/auth/models/session"
import { OneCImportDialog, EMPLOYEE_ROLES } from "modules/spending/onec/components/OneCImportDialog"
import { OneCStoreType } from "modules/spending/onec/models/onec-store"
import { LocalLoader } from "modules/common/components/loader/Loader"
import { withNavigation, NavigationProps, type Location } from "modules/common/components/routing/withNavigation"

const menu = menuItems()

const NotesMultiSelect = MultiSelect.ofType<SelectItem>()

/** Выпадающий список ровно по ширине поля */
const MATCH_TARGET_WIDTH = matchTargetWidthPopover()

class EmployeePage extends React.Component<EmployeePageProps, EmployeePageState> {
  constructor(props: EmployeePageProps) {
    super(props)

    this.state = {
      employerId: getSelectedEmployerId(props.location.pathname),
      showRemoved: false,
      printNotes: [],
      showPrint: false,
      loadingPrint: false,
      loading: false,
      showImport: false,
    }
  }

  async componentDidMount() {
    document.title = menu.spending.nested.employee.label

    const { store } = this.props
    const { employerId } = this.state
    store.init(employerId)
  }

  componentDidUpdate(prevProps: NavigationProps) {
    // смена адреса приходит новым location в пропах
    if (prevProps.location !== this.props.location) {
      this.onLocationChanged(this.props.location)
    }
  }

  onLocationChanged = async (location: Location) => {
    const userId = getSelectedEmployerId(location.pathname)

    if (this.state.employerId !== userId) {
      this.setState({ employerId: userId, loading: true })

      await this.loadDetails(userId)
      this.setState({ loading: false })
    }
  }

  // openFolder = () => {
  //   const path = "\\\\10.136.10.10\\Obmen"

  //   // Пробуем открыть через file://
  //   const url = `file:\\\\${path}`

  //   // Способ 1: через window.open
  //   const newWindow = window.open(url)

  //   // Способ 2: через создание ссылки
  //   const link = document.createElement('a')
  //   link.href = url
  //   link.click()

  //   // Если не работает — выводим инструкцию
  //   setTimeout(() => {
  //     alert("Если папка не открылась:\n1. Скопируйте путь:\n" + path + "\n2. Нажмите Win+R и вставьте его")
  //   }, 1000)
  // };
  render() {
    const { store, access, baseUrl } = this.props
    const { showRemoved, loading } = this.state
    const canChange = can(func.EMPLOYER_EDIT, access)
    const canImport = can(func.ONEC_IMPORT, access)
    const orderAccess = canReadOrder(access)

    return (
      <Block columned={true} className={styles.page}>
        {/* список сотрудников приходит долго: без индикатора страница выглядит пустой.
            Ниже окон Blueprint (z-index 20): список перечитывается после сохранения карточки,
            и индикатор не должен закрывать открытую карточку */}
        <LocalLoader active={store.isLoading} text="Загрузка сотрудников..." zIndex={10} />

        <WhenPath path={routes.spending.employee.details()}>
          {this.state.employerId && !loading && (
            <DetailsPopup title={this.title(store.details.name)} onCancel={this.onEmployerSelected} width={1310}>
              <EmployerDetails
                baseUrl={baseUrl}
                positions={store.positions}
                employer={store.details}
                onSaved={this.onEmployerSaved}
                onRemoved={this.onEmployerRemoved}
                canChange={canChange}
                onPrintCredentials={store.printCredentials}
                spendings={store.projects}
                orderAccess={orderAccess}
                employerList={store.list}
                employerId={this.state.employerId}
                portfolios={store.portfolios}
                documentNotes={store.sortedDocumentNotes}
                departments={store.departmentOptions}
                canOpenPositions={canAny([func.DEPARTMENT_READ, func.DEPARTMENT_EDIT], access)}
                canSalary={can(func.SCHEDULE_EDIT, access)}
              />
            </DetailsPopup>
          )}

        </WhenPath>
        <Dialog
          icon="info-sign"
          title="Печать документов"
          canEscapeKeyClose={true}
          canOutsideClickClose={false}
          isOpen={this.state.showPrint}
          onClose={this.printHide}
          style={{ width: `600px` }}
          backdropClassName="standard"
        >
          <div className={Classes.DIALOG_BODY} style={{ margin: "auto", width: "100%" }}>
            <div className={styles.documentSelector}>
              <NotesSelect
                notes={store.sortedDocumentNotes}
                selected={this.state.printNotes}
                onChange={(printNotes) => this.setState({ printNotes })}
              />
            </div>
            {this.state.loadingPrint && (
              <div style={{ margin: "0 auto", display: "flex" }}>
                <span className={styles.spanDocumentSelector} style={{ textAlign: "right", marginLeft: "65px" }}>
                  Загрузка документов...
                </span>
                {<Spinner intent="primary" size={25} />}
              </div>
            )}
            {!this.state.loadingPrint && !!store.sortedDocumentNotes.length && (
              <PlanrButton
                type="blueish"
                style={{ margin: "0 auto" }}
                disabled={!this.state.printNotes.length}
                onClick={async () => {
                  this.setState({ loadingPrint: true })
                  await store.printDocuments(this.state.printNotes)

                  this.setState({ loadingPrint: false })
                }}
              >
                Распечатать
              </PlanrButton>
            )}

            {!store.sortedDocumentNotes.length && (
              <span className={styles.spanDocumentSelector}>Документы сотрудников пока не загружены</span>
            )}
          </div>
        </Dialog>

        <div className={styles.tools}>
          {canChange && !showRemoved && (
            <PlanrButton
              type="secondary"
              size="small"
              icon="general-plus-big"
              onClick={this.onEmployerAdd}
              style={{
                width: "230px",
                marginBottom: "32px",
                borderRadius: "120px",
              }}
            >{`${texts.add} сотрудника`}</PlanrButton>
          )}

          {canImport && !showRemoved && (
            <PlanrButton
              type="graybtn"
              size="small"
              icon="general-import"
              onClick={() => this.setState({ showImport: true })}
              style={{
                width: "200px",
                marginBottom: "32px",
                borderRadius: "120px",
              }}
            >
              Импорт из 1С
            </PlanrButton>
          )}

          <OneCImportDialog
            isOpen={this.state.showImport}
            onClose={() => this.setState({ showImport: false })}
            store={this.props.onec}
            entityKey="employees"
            title="Импорт сотрудников из 1С"
            roles={EMPLOYEE_ROLES}
            onImported={() => store.list.load()}
          />

          <PlanrButton
            type="graybtn"
            size="small"
            icon="general-ppl"
            onClick={this.toggleVisibility}
            className={styles.toggler}
            style={{
              width: "260px",
              marginBottom: "32px",
              borderRadius: "120px",
            }}
          >
            {showRemoved ? "Показать активных" : "Показать удаленных"}
          </PlanrButton>

          <div className={styles.right}>
            <PlanrButton
              type="graybtn"
              icon="general-export"
              onClick={store.export}
              title={texts.export}
              round={true}
            />
            <PlanrButton type="graybtn" icon="general-print" round={true} onClick={this.printShow} title="Печать" />
            <Search query={store.list.query} onSearch={store.list.setQuery} />
          </div>
        </div>
        <EmployerList
          store={store.list}
          onEmployerSelected={this.onEmployerSelected}
          hidden={showRemoved}
          onEmployerRemove={this.onEmployerRemove}
          canChange={canChange}
          portfolios={store.portfolios}
        />

        <RemovedList
          store={store.removed}
          onEmployerSelected={this.onEmployerSelected}
          hidden={!showRemoved}
          onEmployerRestore={this.onEmployerRestore}
          canChange={canChange}
        />
      </Block>
    )
  }

  title = (header: string) => (
    <EmployerCardTitle
      header={header}
      store={this.props.store}
      employerId={this.state.employerId}
      access={this.props.access}
      materials={this.props.materials}
      orderAccess={canReadOrder(this.props.access)}
    />
  );

  printHide = () => this.setState({ showPrint: false });

  printShow = () => {
    // примечания завели минуту назад в карточке — список должен быть свежим
    this.props.store.loadDocumentNotes()
    this.setState({ showPrint: true })
  };

  toggleVisibility = () => this.setState({ showRemoved: !this.state.showRemoved });

  onEmployerAdd = () => {
    this.onEmployerSelected(EMPTY_OBJECT_ID)
  };

  onEmployerSelected = (id: string = "") => {
    const { navigate } = this.props

    const url = id ? routes.spending.employee.details(id) : routes.spending.employee.path

    navigate(url)
  };

  onEmployerRestore = async (id: string = "") => {
    const user = this.props.store.removed.asMap[id]
    if (user) {
      const ok = await user.restore()
      if (ok) {
        this.loadList()
        this.loadRemovedList()
      }
    }
  };

  onEmployerRemove = async (id: string = "") => {
    const user = this.props.store.list.asMap[id]
    if (user) {
      const ok = await user.delete()
      if (ok) {
        this.onEmployerRemoved()
      }
    }
  };

  onEmployerSaved = async (id: string) => {
    this.onEmployerSelected(id)
    await this.loadList()
  };

  onEmployerRemoved = () => {
    const { navigate } = this.props

    this.loadList()
    this.loadRemovedList()

    const url = routes.spending.employee.path
    navigate(url)
  };

  loadList = () => this.props.store.list.load();

  loadRemovedList = () => this.props.store.removed.load();

  loadDetails = async (id: string) => {
    await this.props.store.details.load(id)
    await this.props.store.premiums.load(id)
    this.props.store.loadSpendings(id)
  };

}

export default withNavigation(observer(EmployeePage))

function getSelectedEmployerId(pathname: string) {
  const match = matchRoute<EmployeeParams>(pathname, routes.spending.employee.details())

  return match && match.params ? match.params.employerId : ""
}

interface EmployeePageProps extends NavigationProps {
  baseUrl: string
  store: EmployeeStoreType
  access: string[]
  materials: MaterialValuesStoreType
  session: SessionType
  onec: OneCStoreType
}

interface EmployeeParams {
  employerId: string
}

interface EmployeePageState extends EmployeeParams {
  showRemoved: boolean
  printNotes: string[]
  showPrint: boolean
  loading: boolean
  loadingPrint: boolean
  showImport: boolean
}

/**
 * Документы для массовой печати: выбирается сразу несколько примечаний — одни и те же
 * документы у разных сотрудников подписаны по-разному (опечатки, разные формулировки)
 */
const NotesSelect = ({ notes, selected, onChange }: NotesSelectProps) => {
  const items = notes.map((note) => ({ id: note, label: note }))

  const toggle = (note: string) =>
    onChange(selected.includes(note) ? selected.filter((item) => item !== note) : [...selected, note])

  return (
    <NotesMultiSelect
      className="full-width-select"
      fill={true}
      items={items}
      itemPredicate={filterItemPredicate}
      itemRenderer={renderCheckedNote(selected)}
      itemsEqual={(a: SelectItem, b: SelectItem) => a.id === b.id}
      noResults={<MenuItem disabled={true} text="Ничего не найдено" />}
      onItemSelect={(item: SelectItem) => toggle(item.id)}
      placeholder="Выберите документы"
      popoverProps={MATCH_TARGET_WIDTH}
      // список остаётся открытым, поэтому активный пункт не сбрасываем
      resetOnSelect={false}
      selectedItems={selected.map((note) => ({ id: note, label: note }))}
      tagRenderer={(item: SelectItem) => item.label}
      tagInputProps={{
        onRemove: (_value: any, index: number) => onChange(selected.filter((_, i) => i !== index)),
      }}
    />
  )
}

/** Пункт списка с отметкой выбранного */
const renderCheckedNote = (selected: string[]): ItemRenderer<SelectItem> => (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null
  }

  return (
    <MenuItem
      key={item.id}
      disabled={modifiers.disabled}
      icon={selected.includes(item.id) ? "tick" : "blank"}
      onClick={handleClick}
      shouldDismissPopover={false}
      text={item.label}
    />
  )
}

interface NotesSelectProps {
  notes: string[]
  selected: string[]
  onChange: (notes: string[]) => void
}
